// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc, ta-code-conventions/has-matching-test */

import * as React from 'react';

type BoostContext = {|
  isBoosted?: boolean,
  itemType?: string,
  itemId?: string,
|};

const initialContext: BoostContext = {
  isBoosted: false,
  itemType: '',
  itemId: '',
};

const BoostTrackingContext: React.Context<BoostContext> = React.createContext(initialContext);

export default BoostTrackingContext;
